export enum DateOffsetType {
  MONTH = 'month',
  YEAR = 'year',
}
export const calculateDateOffset = (date: Date, type: DateOffsetType, offset: number): Date => {
  switch (type) {
    case DateOffsetType.MONTH:
      date.setMonth(date.getMonth() + offset);
      break;
    case DateOffsetType.YEAR:
      date.setFullYear(date.getFullYear() + offset);
      break;
  }
  return date;
};
